import { useState } from 'react'
import type { TIconProps } from '~/components/icon'
import type { TRadioSizes } from '../radio.types'

export function UseRadio() {
  const [selectedValue, setSelectedValue] = useState('')

  const isChecked = (value: string, checked?: boolean) => {
    if (checked) return checked
    return selectedValue === value
  }

  const iconSizeMapping: Record<TRadioSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'small',
    lg: 'medium',
    xl: 'medium',
  }

  return {
    UseRadio,
    selectedValue,
    setSelectedValue,
    isChecked,
    iconSizeMapping,
  }
}
